import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarmClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "alarm-clock" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 12.75,
			r: 9
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6,
			y1: 23.25,
			x2: 7.386,
			y2: 20.479
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 12.75,
			x2: 8.609,
			y2: 12.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 7.5,
			x2: 12,
			y2: 12.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 1.5,
			y1: 3.75,
			x2: 5.25,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18,
			y1: 23.25,
			x2: 16.614,
			y2: 20.478
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 22.5,
			y1: 3.75,
			x2: 18.75,
			y2: .75
		})
	]
});
export default SvgAlarmClock;
